var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTictok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.825 4.94665C13.749 4.46169 13.846 0 13.846 0H10.5731V14.0901C10.4906 15.597 9.24461 16.7766 7.73546 16.7766C6.16593 16.7766 4.89358 15.5042 4.89358 13.9347C4.89358 12.3652 6.16593 11.0928 7.73546 11.0928C8.06669 11.0928 8.39538 11.1507 8.70667 11.2639L8.73878 7.54382C8.39235 7.48507 8.04158 7.45555 7.6902 7.45555C4.22614 7.45555 1.41797 10.2637 1.41797 13.7278C1.41797 17.1918 4.22614 20 7.6902 20C11.036 20 13.7927 17.3739 13.955 14.0321V6.69253C13.955 6.69253 15.7536 8.24443 18.825 8.30909V4.94665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTictok);
export default __webpack_public_path__ + "static/media/tictok.37be2467eb143a8a305043008fac709b.svg";
export { ForwardRef as ReactComponent };